import { connect } from 'react-redux'
import { IDispatchProps, IStateProps, Welcome } from './Welcome'
import { reLocate } from '../../common/Routes/RouterActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserDto, isAuthenticated, isResetPasswordInProgress } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  authenticated: isAuthenticated(state),
  userDto: getUserDto(state),
})

const mapDispatchToProps: IDispatchProps = {
  reLocate,
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome)
